import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let AlertsInfoApproveCheckmarkIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M8.933 20.5L.258 11.735c-.11-.113-.52-.891 0-1.425.212-.255.522-.401.848-.401.326 0 .636.146.848.4l6.979 6.216L22 3.743c.316-.324 1.381-.324 1.697 0 .725.744-.095 1.838 0 1.74L8.933 20.5z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
AlertsInfoApproveCheckmarkIcon = __decorateClass([
  customElement("elm-alerts-info-approve-checkmark-icon")
], AlertsInfoApproveCheckmarkIcon);
export { AlertsInfoApproveCheckmarkIcon };
